import React from 'react';
import iconSrc from 'images/comments-blankstate.svg';

export default prop => (
  <div className="CommentaryBlankSlate">
    <div
      className="CommentaryBlankSlate-icon"
      style={{ background: `url(${iconSrc})` }}
    />
    <h3 className="CommentaryBlankSlate-heading">
      Stop, Collaborate, and Listen
    </h3>
    <p>
      Mention a team member using the @ symbol and they will be notified via
      email.
    </p>
  </div>
);
